import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { getLoaders } from '../../selectors';
import { updateSurveys } from '../../actions';
import { playerLink } from 'routes';
import { withScrollPosition } from 'utils/scrollHelpers';
import ASQSimpleSurveysTable from '../../components/asqs/ASQSimpleSurveysTable';

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    isLoading: getLoaders(state, ['SURVEYS_FILTER', 'SURVEYS']),
    isFetching: state.surveys.isFetching,
    location: state.router.location,
    meta: state.meta.surveys,
    playerId: state.accountPlayer.player.id,
    surveys: state.accountPlayer.player.playerQuestionnaires,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {

    onLoadMore: () => {

    },

    onASQLink: (playerId, ageRange, bankId, from, pqType, pqId) => {
      const link = playerLink(playerId, ageRange, bankId, withScrollPosition(from));
      if (pqType && pqId) {
        link.search = `${link.search}&${pqType}=${pqId}`;
      }
      dispatch(push(link));
    },
    onSortChange: (sort, order) => {
      dispatch(updateSurveys({sort, order, init: true}, {source: 'init'}))
    },
  }
}

const ASQSimpleSurveysContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ASQSimpleSurveysTable)

export default ASQSimpleSurveysContainer;
